<div class="bg special bg_collapse">
  <!-- <app-header></app-header> -->
  <div class="container">
    <div class="row" align="right">
      <div class="col-12 p-2 mt-2 ">
        <button type="button" class="btn btn-primary add-btn" aria-haspopup="true" aria-expanded="false"><i
            class="fas fa-plus"></i> Add User</button>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-2 mt-2 ">
        <div class="card">
          <!---Title-->
          <div class="row d-flex p-3 m-0 border-bottom">
            <div class="heading_1  mr-auto ">Pending Requests</div>
            <div class="heading_1 "><input class="form-control" id="myInput" type="text" placeholder="Search.."></div>

          </div>
          <!---row loop-->
          <div class="row p-3 m-0 border-bottom">
            <div class="col p-0">
              <div class="row">
                <div class="col-12 col-md-4 col-lg-3 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">User Name </span></div>
                    <div><span class="heading_3">SHYAM</span></div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-3 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Email Id</span></div>
                    <div><span class="heading_3">Test@gmail.com</span></div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-3 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Role</span></div>
                    <div><span class="heading_3">Admin</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto d-flex p-0 border-left">
              <div class="buttons_column align-self-center  p-0">
                <button type="button" class="btn btn-custom_primary ml-2 mr-2" id="inv_setup_save" data-toggle="modal"
                  data-target="" data-backdrop="static" data-keyboard="false">Approve </button>
                <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_save" data-toggle="modal"
                  data-target="" data-backdrop="static" data-keyboard="false">Decline</button>
              </div>
            </div>
          </div>

          <!---row loop-->
          <div class="row p-3 m-0 border-bottom">
            <div class="col p-0">
              <div class="row">
                <div class="col-12 col-md-4 col-lg-3 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">User Name </span></div>
                    <div><span class="heading_3">SHYAM</span></div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-3 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Email Id</span></div>
                    <div><span class="heading_3">Test@gmail.com</span></div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-3 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Role</span></div>
                    <div><span class="heading_3">Admin</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto d-flex p-0 border-left">
              <div class="buttons_column align-self-center  p-0">
                <button type="button" class="btn btn-custom_primary ml-2 mr-2" id="inv_setup_save" data-toggle="modal"
                  data-target="" data-backdrop="static" data-keyboard="false">Approve </button>
                <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_save" data-toggle="modal"
                  data-target="" data-backdrop="static" data-keyboard="false">Decline</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>